// extracted by mini-css-extract-plugin
module.exports = {"container":"_10ReEZGW","inputText":"wkDIzIMn","editActions":"_2FIcMTX4","labelDefault":"_1p21OrGF","labelError":"_14yruQyj"};